addEventListener("DOMContentLoaded", () => {
    /* open insta links in new tab */
    addEventListener("click", e => {
	    let a = e.target.closest('a');
	    if (a && a.hostname.includes('instagram.com')) {
		    e.preventDefault();
		    window.open(a.href, '_blank', 'noopener,noreferrer');
	    }
    });

	document.querySelectorAll('footer rte-formatter p')
		.forEach(block => block.textContent = block.textContent.replace(/\d{4}/, new Date().getFullYear()));
});